<div class="relative inline-block" [clickOutsideEnabled]="showOptions" (clickOutside)="esconderOpcoes($event)">
    <div
        class="cursor-pointer w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary/10 transition-colors"
        [ngClass]="{ 'bg-primary/10': showOptions }"
        (click)="exibirOpcoes($event)"
    >
        <i class="fa fa-ellipsis-v text-primary"></i>
    </div>

    <ul
        #menu
        class="absolute z-9999 m-0 p-1 list-none bg-white border border-primary/20 shadow-xl rounded-md"
        [class.hidden]="!showOptions"
        [ngStyle]="popupStyle"
    >
        @for (opcao of options; track opcao) {
            <li
                class="group cursor-pointer px-3 py-1.5 rounded hover:bg-primary flex items-center gap-3 text-[14px] text-primary transition-colors whitespace-normal wrap-break-word"
                (click)="opcaoClicada($event, opcao)"
            >
                @if (opcao.icon) {
                    <i
                        [class]="
                            opcao.icon +
                            ' font-normal text-primary group-hover:text-white text-center w-4 shrink-0 transition-colors'
                        "
                    ></i>
                }

                <span class="group-hover:text-white transition-colors">{{ opcao.label }}</span>
            </li>
        }
    </ul>
</div>